import { type FC } from "react";

import { useSelectedOrganization } from "../../organizations/hooks";
import { GroupsTableContainer } from "../components/groups-table/GroupsTable";

interface GroupsContainerV2Props {
    onNewLensGroup: () => void;
}

export const GroupsContainerV2: FC<GroupsContainerV2Props> = ({ onNewLensGroup }) => {
    const { permissions } = useSelectedOrganization();

    return <GroupsTableContainer onNewLensGroup={onNewLensGroup} readonly={!permissions?.updateGroups!} />;
};
